import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import svgs from '../../resources/svgs';

import './FormElementWrapper.scss';

class FormElementWrapper extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hasHover: false,
		};

		this.handleLabelClick = this.handleLabelClick.bind(this);
	}

	// Event Handlers
	handleLabelClick() {
		if (!this.props.hasFocus && !this.props.hasValue) {
			this.props.onLabelClick();
		}
	}

	render() {
		const props = this.props;
		const showLabel = !props.hideLabel && !props.hidden;
		const children = Array.isArray(props.children) ? props.children : [props.children];

		return (
			<div
				className={cx(
					'form-element-wrapper',
					`form-element-wrapper__for-${props.name}`,
					{
						'form-element-wrapper__required': props.required,
						hidden: props.hidden,
						'form-element-wrapper__with-label': showLabel,
						'form-element-wrapper__label-locked': props.lockLabel,
						'form-element-wrapper__has-focus': props.hasFocus,
						'form-element-wrapper__has-hover': this.state.hasHover,
						'form-element-wrapper__is-filled': props.hasValue,
						'form-element-wrapper__has-error': props.showError,
					},
					props.className
				)}
				onMouseOver={() => this.setState({ hasHover: true })}
				onMouseOut={() => this.setState({ hasHover: false })}>
				{props.tooltip && (
					<div className="form-element-wrapper__tooltip">
						<div className="form-element-wrapper__tooltip-content">
							<div className="form-element-wrapper__tooltip-content-text">{props.tooltip}</div>
						</div>
						{svgs.description}
					</div>
				)}

				<label className="form-element-wrapper__label" htmlFor={props.name}>
					{showLabel && (
						<div className="form-element-wrapper__label-wrapper">
							<div className="form-element-wrapper__label-div" onClick={this.handleLabelClick}>
								<span title={props.label} dangerouslySetInnerHTML={{ __html: props.label }}></span>
								{!props.required && <span className="form-element-wrapper__optional">({this.props.optionalLabel || 'optional'})</span>}
							</div>
						</div>
					)}
					<div className="form-element-wrapper_children">{children.map((childElm, idx) => React.cloneElement(childElm, { key: idx }))}</div>
					<div className={cx('form-element-wrapper__error', { 'is-active': props.showError })}>{props.errorMessage}</div>
				</label>
			</div>
		);
	}
}

FormElementWrapper.propTypes = {
	required: PropTypes.bool,
	hasFocus: PropTypes.bool,
	hasValue: PropTypes.bool,
	hidden: PropTypes.bool,
	hideLabel: PropTypes.bool,
	lockLabel: PropTypes.bool,
	label: PropTypes.string,
	tooltip: PropTypes.string,
	optionalLabel: PropTypes.string,
	className: PropTypes.string,
	name: PropTypes.string.isRequired,
	showError: PropTypes.any,
	errorMessage: PropTypes.string,
};

export default FormElementWrapper;
